'use client';

import { useEffect } from 'react';
import Header from '@/components/common/Header';
import Footer from '@/components/common/Footer';
import Chatbot from '@/components/common/Chatbot';
import ProfileDashboard from './components/ProfileDashboard';
import { analytics } from '@/lib/analytics';

export default function ProfilePage() {
  useEffect(() => {
    analytics?.trackPageView('/profile');
  }, []);

  return (
    <>
      <Header />
      <main className="min-h-screen bg-background pt-24">
        {/* Page Header */}
        <div className="bg-gradient-to-br from-primary/5 to-secondary/5 py-12 border-b border-border">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <h1 className="text-4xl md:text-5xl font-heading font-bold text-foreground mb-4">
              My Profile
            </h1>
            <p className="text-lg text-muted-foreground">
              Manage your shipments, quotes, and account settings
            </p>
          </div>
        </div>

        <ProfileDashboard />
      </main>
      <Footer />
      <Chatbot />
    </>
  );
}